import { useAuth } from "../../Contexts/AuthContext"
import ExpenseGroupList from "../../Components/ExpenseGroupList"

export default function Home() {
  const { user } = useAuth()
  return (
    <div className="p-2">
      <h4 className="text-muted my-4">
        {user ? `Welcome ${user?.username}` : "You are not logged in"}
      </h4>
      {
        user && (
          <>

            <div className="alert alert-info">
              <i className="bx bx-info-circle"></i> &nbsp;
              <span>
                Click on the
                <button className="btn btn-sm btn-outline-primary mx-2" disabled>
                  <i className="bx bx-dollar"></i>
                </button>
                icon to add an expense
              </span>
            </div>
            <ExpenseGroupList />
          </>

        )
      }
    </div>
  )
}
